export const styles = (theme) => ({
  root: {
    padding: 20,
    height: '100%',
    display: 'flex',
    flexFlow: 'column'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  heading: {
    fontSize: 20,
    lineHeight: "30px",
    color: "#333",
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    "& span": {
      fontWeight: 400
    },
    marginBottom: 12
  },
  summaryViewBox: {
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    flexFlow: 'column',
    background: '#FFFFFF',
    border: '1px solid #DADADA',
    boxSizing: 'border-box',
  },
  summaryData: {
    margin: '24px 0',
    display: 'grid',
    gridAutoFlow: 'column',
    gap: 50,
  },
  dataBox: {
    display: 'flex',
    alignItems: 'center'
  },
  colorBox: {
    borderRadius: 2,
    width: 16,
    height: 16
  },
  dataText: {
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 400,
    color: "rgba(51, 51, 51, 0.75)",
    "& span": {
      fontWeight: 600,
      color: "#333"
    },
    marginLeft: 8
  },
  summaryChartBox: {
    width: "100%",
    padding: "0 16px 20px"
  },
  summaryChart: {
    width: '100%',
    height: 20,
    borderRadius: 20,
    display: 'grid',
    gridAutoFlow: 'column',
    gap: 0,
    overflow: 'hidden'
  },
  summaryLabels: {
    width: '100%',
    display: 'grid',
    gridAutoFlow: 'column',
    justifyItems: 'end',
    gap: 0,
    "& p": {
      fontSize: 14,
      lineHeight: '20px',
      color: '#333',
    },
    position: 'relative'
  },
  datumPoint: {
    position: 'absolute',
    left: 0
  },
  divider: {
    margin: '0 12px'
  },
  cupIcon: {
    width: 15,
    height: 16,
    fill: 'none',
    margin: 8
  },
  alertIcon: {
    width: 16,
    height: 16,
    fill: 'none',
    margin: 8
  },
  tableShowRoot: {
    height: '100%',
    display: 'flex',
    flexFlow: 'column'
  }
})

export const tableStyles = {
  tableRoot: `
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
    background: #FFFFFF;
    border: 1px solid #DADADA;
  `,
  tableLayout: `
    display: grid;
    grid-template-columns: 50px 60% auto;
  `,
  tableHeader: `
    box-shadow: 0px 2px 0px #DADADA;
    padding: 14px;
  `,
  tableHeaderText: `
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    padding: 0 10px;
  `,
  NCRoot: `
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    padding: 20px;
  `,
  NCText: `
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: rgba(51, 51, 51, 0.75);
    margin-top: 14px;
  `,
  tableRow: `
    border-bottom: 1px solid #EEE;
    padding: 14px;
  `,
  tableRowText: `
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    padding: 0 10px;
  `,
  percentage: `
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: rgba(51, 51, 51, 0.5);
    margin-left: 24px;
  `,
  stats: `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 22px;
  `,
}